import { render, staticRenderFns } from "./InstantMarketingOrdersDetails.vue?vue&type=template&id=573a493f&"
import script from "./InstantMarketingOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./InstantMarketingOrdersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports